// extracted by mini-css-extract-plugin
export default {"blue":"style_blue__mbsBc"};